// ForgotPassword.tsx
import React, { useState } from "react";
import { Form, Button, Alert, Container, Spinner } from "react-bootstrap";
import { useMutation } from "react-query";
import apiClient from "../api";
import { Helmet } from "react-helmet-async";

const ForgotPassword = () =>{
  const [email, setEmail] = useState<string>("");
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const mutation = useMutation(
    async (email: string) => {
      const response = await apiClient.post("/auth/forgot-password", { email });
      return response.data;
    },
    {
      onSuccess: (data: any) => {
        setMessage(data?.message || "Rest password link sent to your email.");
        setError(null);
      },
      onError: (error: any) => {
        setMessage(null);
        setError("Something went wrong. Please try again or contact admin.");
      },
    }
  );

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    mutation.mutate(email);
  };

  return (
    <Container className="mt-5"  style={{ maxWidth: '500px' }}>
      <Helmet>
        <title>Forgot Password - QuickyChat</title>
        <meta name="description" content="Reset your password for QuickyChat by entering your email address." />
      </Helmet>
      <Form onSubmit={handleSubmit}>
        <h3 className="text-center mb-4">Forgot Password</h3>
        <p>
          Enter your email address and we will send you a link to reset your password.
        </p>
        {message && <Alert variant="success">{message}</Alert>}
        {error && <Alert variant="danger">{error}</Alert>}
        <Form.Group controlId="formEmail" className="mb-3">
          <Form.Label>Email Address</Form.Label>
          <Form.Control
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required/>
        </Form.Group>
        <Button 
          variant="primary" 
          type="submit" 
          disabled={mutation.isLoading} 
          className="w-100">
          {mutation.isLoading && <Spinner animation="border" size="sm" />} Login
        </Button>
      </Form>
    </Container>
  );
};

export default ForgotPassword;
